import { Component, Input, OnInit } from "@angular/core";

import { DirectoryItemModel } from "../../models/directory-item.model";
import { SearchTabConfigModel } from "../../models/search-tab-config.model";
import { PdfDropdownManager } from "../../../../../shared-library/types/pdf-dropdown-manager";
import { BehaviorSubject, fromEvent } from "rxjs";
import { map } from "rxjs/operators";

declare function externalGetPdfDropdown(): InstanceType<PdfDropdownManager> | undefined;

@Component({
    selector: "pcg-ng-directory-item-details-card",
    template: require('./directory-item-details-card.component.html')
})
export class DirectoryItemDetailsCardComponent implements OnInit {
    @Input() public itemToDisplay: DirectoryItemModel;
    @Input() public searchTabConfig: SearchTabConfigModel;

    protected pdfDropdown = externalGetPdfDropdown();
    protected isInBooklet$: BehaviorSubject<{ is: boolean }>;

    public ngOnInit(): void {
        this.isInBooklet$ = new BehaviorSubject<{is: boolean}>({is: this.isInBooklet});

        fromEvent(window, "sc-my-favourites__update").pipe(
            map(e => this.isInBooklet)
        ).subscribe(is => this.isInBooklet$.next({ is: is }));
    }

    public addToBooklet(e: Event): void {
        e.preventDefault();

        if (!!this.pdfDropdown) {
            if (!this.isInBooklet) {
                this.pdfDropdown.addEvent(this.itemToDisplay.id, this.itemToDisplay.name, this.getDetailsPageUrl(false));
            }
        }

        this.isInBooklet$.next({is: this.isInBooklet});
    }

    public removeFromBooklet(e: Event): void {
        e.preventDefault();

        if (!!this.pdfDropdown) {
            const items = this.pdfDropdown.getItems();
            const itemToDelete = items.find(i => i.eventId === this.itemToDisplay.id);
            if (!!itemToDelete) {
                this.pdfDropdown.removeEvent(itemToDelete.key);
            }
        }

        this.isInBooklet$.next({is: this.isInBooklet});
    }

    public getDetailsPageUrl(includeReturnUrl: boolean = true): string {
        return `${this.searchTabConfig.viewPageUrl}?id=${this.itemToDisplay.id}` + (includeReturnUrl ? `&returnUrl=${this.base64UrlEncode(window.location.href)}` : "");
    }

    private base64UrlEncode(str: string): string {
        const utf8Bytes = new TextEncoder().encode(str);
        let binary = "";

        for (const utf8Byte of utf8Bytes) {
          binary += String.fromCharCode(utf8Byte);
        }

        const base64 = btoa(binary);

        return base64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
    }

    public getWebsiteAddress(): string {
        return (this.itemToDisplay.website.toLowerCase().startsWith("http") ? "" : "http://") + this.itemToDisplay.website;
    }

    public get isInBooklet(): boolean {
        const items = this.pdfDropdown?.getItems() ?? [];
        return !!items.find(i => i.eventId === this.itemToDisplay.id);
    }
}
